$.ajaxSetup({
    headers: { 'X-CSRF-Token' : $('meta[name=_token]').attr('content') }
 });

/** Gets a URL parameter value */
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

$( document ).ready(function() {
	function checkScroll(){
	    var startY = $('.navbar').height() / 4;

	    if($(window).scrollTop() > startY)
	        $('.navbar').addClass("scrolled");
		else
	        $('.navbar').removeClass("scrolled");
	}

	if($('.navbar').length > 0)
	{
	    $(window).on("scroll load resize", function(){
	        checkScroll();
	    });
	}
});





	
	

	
